var $ = jQuery;
import {debounce} from '../utils/utilities.js';


function init() {

  if($('.event__sticky').length) {
    const videoContainer = $('.video__wrapper');
    const stickyModule = $('.event__sticky');
    const stickyClose = $('.event__sticky-close');
    let videoPosition =  0;

    var hideShow = debounce(function() {
      let scrollPos = $(window).scrollTop();
      if(scrollPos > videoPosition && !stickyModule.hasClass('_expanded')) {
        stickyModule.addClass('_expanded');
      }
      else if(scrollPos < videoPosition && stickyModule.hasClass('_expanded')) {
        hideModule(stickyModule);
      }
    }, 50);

    var updateVideoBottom = debounce(function() {
      videoPosition = videoContainer.offset().top + videoContainer.outerHeight();
    });

    updateVideoBottom();

    //binds scroll to hide and show the module
    $(window).on('scroll', hideShow);

    //reset video position variable on resize
    $(window).on('resize', updateVideoBottom);

    stickyClose.on('click', function(event) {
      event.preventDefault();
      stickyModule.remove();
      $(window).off('scroll', hideShow);
      $(window).off('resize', updateVideoBottom);
      //$('.event__sticky-wrapper a').off('click');
    });

    /*/scroll to video when clicking on the links of the sticky module
    $('.event__sticky-wrapper a').on('click', function(event) {
      event.preventDefault();
      $('html, body').animate({
        scrollTop: videoContainer.offset().top
      }, 1000);
    });*/
  }

  function hideModule(module) {
    module.removeClass('_expanded');
  }
}

export {init as init};
